import styled from "styled-components";

interface StyledDashboardProps {
  $isVisible: boolean;
}

export const StyledDashboard = styled.div<StyledDashboardProps>`
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transform: ${(props) =>
    props.$isVisible ? "translateY(0)" : "translateY(20px)"};
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;

  .dashboard-container {
    padding: 0 25px;
  }
`;

export const StyledSubTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  text-align: right;

  h2 {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 18px;
  }
`;
